import React from 'react';

import {SidebarItem} from 'app/general/structures/SidebarItem';
import {ProcedurePoliciesSidebar} from 'app/procedures/components/ProcedureDetailPage/ProcedurePageSidebar/ProcedurePoliciesSidebar';
import {ProcessPoliciesSidebar} from 'app/process/components/ProcessPageSidebar/ProcessPoliciesSidebar';
import {getObjectPoliciesURL} from 'app/urls';
import {getContentType} from 'app/utils/content-type';

import type {
  LeftSidebarElementType,
  LeftSidebarMenuButton,
  LeftSidebarPanelType,
} from 'app/components/general/DetailPage/LeftSidebar/structure/types';
import type {
  ProcedureHashidSerializedType,
  ProcessHashidSerializedType,
} from 'sweet-types';

function PoliciesForProcessPanelContent({
  object,
}: LeftSidebarPanelType<ProcessHashidSerializedType>) {
  return <ProcessPoliciesSidebar process={object} items={object.policies} />;
}

function PoliciesForProcedurePanelContent({
  object,
  legacyRefetch,
}: LeftSidebarPanelType<ProcedureHashidSerializedType>) {
  return (
    <ProcedurePoliciesSidebar
      procedure={object}
      items={object.policies}
      legacyRefetchData={() => {
        legacyRefetch();
        return Promise.resolve();
      }}
    />
  );
}

function PoliciesMenuButton<
  ItemType extends ProcedureHashidSerializedType | ProcessHashidSerializedType
>({
  object,
  forceTooltipShow,
  hideTooltip,
  location,
  active,
}: LeftSidebarMenuButton<ItemType>) {
  const contentType = getContentType('policy');
  return (
    <SidebarItem
      title={contentType.pluralName}
      active={active}
      icon={contentType.icon}
      link={getObjectPoliciesURL(object, location.search)}
      forceTooltipShow={forceTooltipShow}
      onClick={hideTooltip}
    />
  );
}

export const PoliciesForProcessLeftSidebar: LeftSidebarElementType<ProcessHashidSerializedType> =
  {
    Panel: PoliciesForProcessPanelContent,
    MenuButton: PoliciesMenuButton,
    type: 'left',
    sidebarName: 'showPolicies',
  };

export const PoliciesForProcedureLeftSidebar: LeftSidebarElementType<ProcedureHashidSerializedType> =
  {
    Panel: PoliciesForProcedurePanelContent,
    MenuButton: PoliciesMenuButton,
    type: 'left',
    sidebarName: 'showPolicies',
  };
